import { PayloadAction } from '@reduxjs/toolkit';

import { DesignDimensions, DesignState } from 'editor/src/store/design/types';

import moveBottomEdgeInPath from 'editor/src/util/gangSheet/moveBottomEdgeInPath';
import limitPrecision from 'editor/src/util/limitPrecision';

const STRUCTURAL_GROUPS = ['bleed', 'safe_area', 'mediabox', 'content', 'blank'] as const;

// Lengthens (or shortens, with a negative delta) the pages of one spread at their bottom
// edge and records the resulting size. Structural rectangles keep their top and stretch,
// as resizeDesignToDimensions does for a custom trim, but media elements are left
// exactly where they are: a rolling gang sheet must never move or rescale the buyer's
// artwork when its length changes.
const extendPageLengthReducer = (
  state: DesignState,
  action: PayloadAction<{ spreadIndex: number; deltaMm: number; dimensions: DesignDimensions }>,
) => {
  const { spreadIndex, deltaMm, dimensions } = action.payload;
  const { designData } = state;
  const spread = designData?.spreads[spreadIndex];
  if (!designData || !spread) {
    return;
  }

  if (deltaMm) {
    spread.pages.forEach((page) => {
      page.height = limitPrecision(page.height + deltaMm);
      STRUCTURAL_GROUPS.forEach((key) => {
        page.groups[key]?.forEach((element) => {
          const bottom = element.y + element.height;
          element.height = limitPrecision(element.height + deltaMm);
          // the canvas draws an element's outline path when it has one, so its bottom edge moves too
          if ('path' in element && typeof element.path === 'string') {
            element.path = moveBottomEdgeInPath(element.path, bottom, limitPrecision(bottom + deltaMm));
          }
        });
      });
    });
  }

  designData.dimensions = dimensions;
};

export default extendPageLengthReducer;
